export default __webpack_public_path__ + "static/media/slider-img7.a005b2e8.jpg";